import { format, isValid, parse } from 'date-fns';

// Date format enumerations
export const DATE_FORMATS = {
  LONG: 'MMMM dd, yyyy',
  SHORT: 'MM/dd/yyyy',
  MICRO: 'yyyyMMddHHmmss.SSS',
  DEFAULT: 'yyyyMMdd',
  FULL: 'YYYYMMDDHHmmssZ',
  UNIX: 'X',
  UNIX_MS: 'x',
};

/**
 * Parse a date stored as a string using a format or list of formats.
 * See https://momentjs.com/docs/#/parsing/string-formats/ for more information.
 *
 * @param {string} date Value to be parsed by `moment(date, inputFormat)`.
 * @param {string|string[]} inputFormat Format(s) used to help parse the string.
 * @param {string} displayFormat Desired format to display.
 */
export const formatDateString = (date, inputFormat, displayFormat) => {
  const parsedDate = parse(date, inputFormat, new Date());
  if (isValid(parsedDate)) {
    return format(parsedDate, displayFormat);
  }

  return '';
};

/**
 * Parse an Object, Date, Array, or string.  When parsing a string first attempts to match
 * an ISO 8601 (https://en.wikipedia.org/wiki/ISO_8601), then RFC 2822 Date time https://tools.ietf.org/html/rfc2822#section-3.3.
 * See https://momentjs.com/docs/#/parsing/string-formats/ for more information.
 *
 * @param {Object|Date|Array|string} date The Object or string to be parsed.
 * @param {string} displayFormat Desired format to display.
 */
export const formatDate = (date, displayFormat) => {
  if (isValid(date)) {
    return format(date, displayFormat);
  }

  return '';
};
